<template>
  <div>
    <Button
      v-if="type == 'with_button'"
      buttonColor="blue"
      hasLeftIcon
      :buttonText="buttonText"
      class="check-button"
      @click="handleCheckAllChange"
    />

    <Divider dividerSize="1" hasLine />
    <el-checkbox-group :max="max" v-model="value">
      <el-checkbox
        v-for="(el, key) in elements"
        :key="key"
        :label="el.name || el"
        :disabled="disabled || el.required"
        @change.native="$emit('change', value)"
        class="custom-checkbox"
        :class="[classes ? classes[key] : '', error == true ? 'is-error' : '']"
        >{{ el.label }}</el-checkbox
      >
    </el-checkbox-group>
  </div>
</template>

<script>
import { Checkbox, CheckboxGroup } from 'element-ui';
import Button from 'Elements/Button/Button';
import Divider from 'Elements/Divider/Divider';
export default {
  props: {
    model: {
      type: [Array, String]
    },
    elements: {
      type: [Array, Object]
    },
    max: {
      type: Number,
      default: 100
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    classes: {
      type: Object,
      default: () => null
    },
    error: { type: Boolean, default: false }
  },
  data() {
    return {
      value: []
    };
  },
  computed: {
    buttonText() {
      return this.value && this.value.length < this.elements.length
        ? 'Выбрать все'
        : 'Снять все';
    }
  },
  created() {
    if (typeof this.model == 'string' && this.model) {
      this.value = this.model.split(',');
    } else if (Array.isArray(this.model)) {
      this.value = this.model;
    }
    this.addRequiredValue();
  },
  methods: {
    handleCheckAllChange() {
      if (this.value && this.value.length < this.elements.length) {
        this.addRequiredValue(true);
      } else {
        this.value = [];
        this.addRequiredValue();
      }
    },
    addRequiredValue(addAll = false) {
      for (let item in this.elements) {
        if (addAll && this.value.indexOf(this.elements[item].name) == -1) {
          this.value.push(this.elements[item].name);
        } else if (
          this.elements[item].required &&
          this.value.indexOf(this.elements[item].name) == -1
        ) {
          this.value.push(this.elements[item].name);
        }
      }
      this.$emit('change', this.value);
    }
  },
  components: {
    'el-checkbox': Checkbox,
    'el-checkbox-group': CheckboxGroup,
    Button,
    Divider
  }
};
</script>

<style lang="scss" scoped>
.check-button {
  margin: 12px 0 16px 0;
}
</style>

<style lang="scss">
.el-checkbox-group {
  margin-top: 16px;

  .is-error {
    .el-checkbox__input {
      .el-checkbox__inner {
        background-image: url('../../../assets/img/checkbox-error.svg') !important;
      }
    }
  }
  .custom-checkbox {
    display: inline-flex;
    margin-bottom: 8px;
    max-height: none;
    width: 100%;
    align-items: center;

    .is-focus {
      padding: 2px !important;
      border: 2px solid $blue80;
      height: 28px;
      width: 28px;
      border-radius: 4px;
      max-height: none !important;
      margin-right: 10px;
    }

    .el-checkbox__label {
      cursor: pointer;
      color: $grey80;
      padding-left: 0 !important;
      word-break: break-word;
      white-space: normal;
    }

    .el-checkbox__label:not(.is-disabled) {
      color: $grey80 !important;
    }

    .el-checkbox__input {
      height: 28px;
      width: 28px;
      padding: 4px;
      margin-right: 10px;

      .el-checkbox__inner {
        border: none;
        background-color: transparent;
        background-image: url('../../../assets/img/checkbox_square.svg');
        background-position: center;
        background-size: contain;
        height: 20px;
        width: 20px;

        &::after {
          display: none;
        }
      }
    }

    &:hover {
      .el-checkbox__inner {
        background-image: url('../../../assets/img/checkbox-hover_square.svg');
      }
    }

    &:not(.is-disabled) .el-checkbox__inner {
      cursor: pointer;
    }

    &.is-disabled:not(.is-checked) {
      cursor: default;

      .el-checkbox__inner {
        background-image: url('../../../assets/img/checkbox-disabled_square.svg');
      }

      .el-checkbox__label {
        color: $grey40;
      }
    }

    &.is-checked:not(.is-disabled) {
      .el-checkbox__inner {
        background-image: url('../../../assets/img/checkbox-checked_square.svg');
      }

      .el-checkbox__label {
        color: $grey80;
      }

      &:hover {
        .el-checkbox__inner {
          background-image: url('../../../assets/img/checkbox-checked-hover_square.svg');
        }
      }
    }

    &.is-disabled {
      .el-checkbox__inner {
        background-image: url('../../../assets/img/checkbox-checked-disabled_square.svg');
      }

      .el-checkbox__label {
        color: $grey40;
      }
    }
  }
}
</style>
